/* ============================================================
   Labella.hu – termékkártya színpötty

   - Egeret ráviszed  -> előnézet: a variáció képe látszik
   - Egeret leveszed  -> visszaáll (a kiválasztott, ill. az eredeti kép)
   - Rákattintasz     -> rögzül: onnantól az lesz a kártya képe,
                         és a kártya linkjei is arra a variációra mutatnak

   A visszaállítás NEM a mouseout/relatedTarget párosra épül (az ragasztotta
   be korábban a képet), hanem globális mouseover-figyelésre: amint az egér
   bármi másra kerül, az előnézet megszűnik.
   Vanilla JS, eseménydelegálás – AJAX-szal betöltött kártyákra is működik.
   ============================================================ */
(function () {
  'use strict';

  var SWATCH_SEL = '[data-swatch-colors] .variant-option';
  var activePreviewCard = null;

  function getCard(el) {
    return el.closest('.product-card');
  }

  function getMedia(card) {
    return card.querySelector('.product-img .media') || null;
  }

  /* A pöttyhöz előtöltött variációs kép beillesztése a fő képmezőbe. */
  function swapMedia(swatchLi) {
    var card = getCard(swatchLi);
    if (!card) return false;
    var media = getMedia(card);
    if (!media) return false;
    var hidden = swatchLi.querySelector('.hidden');
    if (!hidden || !hidden.innerHTML.trim()) return false;

    if (!card.labellaOriginalMedia) {
      card.labellaOriginalMedia = media.innerHTML;
    }
    media.innerHTML = hidden.innerHTML;
    /* lazysizes: az előtöltött másolat feldolgozását kikényszerítjük */
    var img = media.querySelector('img');
    if (img && !img.classList.contains('lazyloaded')) {
      img.classList.add('lazyload');
    }
    return true;
  }

  /* Visszaállítás: ha van kattintással rögzített pötty, arra; különben az eredetire. */
  function restore(card) {
    if (!card) return;
    if (card.labellaLockedLi && card.contains(card.labellaLockedLi)) {
      if (swapMedia(card.labellaLockedLi)) return;
    }
    if (card.labellaOriginalMedia) {
      var media = getMedia(card);
      if (media) media.innerHTML = card.labellaOriginalMedia;
    }
  }

  function clearPreview() {
    var card = activePreviewCard;
    if (!card) return;
    activePreviewCard = null;
    card.labellaPreviewLi = null;
    restore(card);
  }

  function preview(li) {
    var card = getCard(li);
    if (!card) return;
    if (activePreviewCard && activePreviewCard !== card) clearPreview();
    if (card.labellaPreviewLi === li) return;
    card.labellaPreviewLi = li;
    activePreviewCard = card;
    swapMedia(li);
  }

  /* Kártya-linkek átírása a variáció URL-jére. */
  function updateCardLinks(swatchLi) {
    var card = getCard(swatchLi);
    if (!card) return;
    var label = swatchLi.querySelector('label[data-variant-url]');
    if (!label) return;
    var url = label.getAttribute('data-variant-url');
    if (!url) return;
    var links = card.querySelectorAll('a[product-image], a.product-title, a.cus-prd-card-img');
    Array.prototype.forEach.call(links, function (a) {
      a.setAttribute('href', url);
    });
  }

  /* Kattintással rögzített választás. */
  function lockSwatch(li) {
    var card = getCard(li);
    if (!card) return;
    var list = li.closest('[data-swatch-colors]');
    if (list) {
      var prev = list.querySelector('li.variant-option.selected');
      if (prev && prev !== li) prev.classList.remove('selected');
      li.classList.add('selected');
      var input = li.querySelector('input.product-option');
      if (input && !input.checked) input.checked = true;
    }
    card.labellaLockedLi = li;
    swapMedia(li);
    updateCardLinks(li);
  }

  /* ------ Előnézet egérrel ------ */
  document.addEventListener('mouseover', function (e) {
    if (!e.target || !e.target.closest) return;
    var li = e.target.closest(SWATCH_SEL);
    if (li) {
      preview(li);
    } else {
      clearPreview();
    }
  });

  /* Ha az egér elhagyja az ablakot */
  document.addEventListener('mouseleave', clearPreview);
  window.addEventListener('blur', clearPreview);
  window.addEventListener('scroll', function () {
    /* görgetésnél is szűnjön meg, ha a pötty már nincs az egér alatt */
    if (activePreviewCard && !activePreviewCard.matches(':hover')) clearPreview();
  }, { passive: true });

  /* ------ Kattintás: rögzítés ------ */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.variant-more')) return; /* a "+N" link maradjon navigáció */
    var li = e.target.closest(SWATCH_SEL);
    if (!li) return;
    lockSwatch(li);
  });

  /* Billentyűzetes / programozott váltás is rögzítsen */
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    var li = e.target.closest(SWATCH_SEL);
    if (!li) return;
    lockSwatch(li);
  });
})();
